import { Navigate, Route, Routes } from "react-router-dom";
import { AuthLayout } from "./auth-layout";
import { LoginForm } from "./login-form";

export function AuthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AuthLayout />}>
        <Route index element={<Navigate to="login" />} />

        <Route path="login" element={<LoginForm />} />
        <Route path="*" element="Auth: Page Not Found" />
      </Route>
    </Routes>
  );
}
